import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';

@Component({
  selector: 'app-product-name',
  templateUrl: 'product-name.component.html',
  styleUrls: ['product-name.component.scss'],
})
export class ProductNameComponent implements OnInit {
  productName: string;

  @Input() productOffering: BehaviorSubject<Partial<ProductOffering>>;

  constructor(private _fb: FormBuilder) {}

  ngOnInit() {
    if (this.productOffering.value && this.productOffering.value.productName) {
      this.productName = this.productOffering.value.productName;
    }
  }

  getProductName() {
    this.productOffering.next({
      ...this.productOffering.value,
      productName: this.productName,
    });
  }
}
